import { orgAPI } from "@/api/api";
import type { IntegrationConnection } from "@cohesive/api-client";
import type { MicrosoftTeamsChatEntity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface UseMicrosoftTeamsChatsProps {
  connection: IntegrationConnection;
  options?: Partial<UseQueryOptions<MicrosoftTeamsChatEntity[], Error>>;
}

export function useMicrosoftTeamsChats({
  connection,
  options = {},
}: UseMicrosoftTeamsChatsProps) {
  return useQuery<MicrosoftTeamsChatEntity[]>({
    queryKey: ["microsoft-teams-chats", connection.id],
    queryFn: async () => {
      const response = await orgAPI.toolbox.execute<
        MicrosoftTeamsChatEntity[],
        Record<string, unknown>
      >({
        integration_connection_id: connection.id,
        action_name: "microsoft-teams-list-chats",
        action_input: {},
      });
      return response.data;
    },
    enabled: !!connection.integration_id,
    staleTime: 1000 * 60,
    ...options,
  });
}
